/* eslint-disable react/static-property-placement */
import useIssuePrescription from 'Hooks/teleconsult/useIssuePrescription';
import ConfirmModal from 'Modules/ConfirmModal/ConfirmModal';
import { removeModal } from 'Redux/modules/modal/actions';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

const ConfirmPrescription = ({ id, data }) => {
  const { conversation, pendingPrescription } = data;

  const { voidPendingPrescription } = useIssuePrescription(conversation);
  const dispatch = useDispatch();
  const {
    status: { voidPrescription },
    error,
  } = useSelector(state => state.webChat.prescription);

  const voidError = voidPrescription === 2 ? error : null;

  const onClose = () => {
    dispatch(removeModal(id));
  };

  const handleConfirm = async () => {
    await voidPendingPrescription(pendingPrescription, onClose);
  };

  return (
    <ConfirmModal
      showModal
      title="Replace existing prescription"
      confirmButtonText="Proceed"
      onClose={onClose}
      onSubmit={handleConfirm}
      error={voidError}
      message={
        <>
          There is an existing prescription in the teleconsult. <br /> By proceeding, this
          prescription will be voided. We will clone it for you to issue a new prescription for
          patient.
        </>
      }
    />
  );
};

ConfirmPrescription.defaultProps = {};
ConfirmPrescription.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.shape({
    onClose: PropTypes.func.isRequired,
    pendingPrescription: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    conversation: PropTypes.shape({}).isRequired,
  }).isRequired,
};

export default ConfirmPrescription;
